import { QUERY_KEYS_SERVICE_AGREEMENTS } from 'api/query-keys';
import { serviceAgreementsService } from 'ogp/services';
import { ServiceAgreementDetailResponse } from 'ogp/services/service-agreements.types';
import { useQuery } from 'react-query';

export const useGetServiceAgreementDetail = (id: string) => {
  const queryFn = async () => await serviceAgreementsService.getServiceAgreementById(id);
  return useQuery<ServiceAgreementDetailResponse, Error, ServiceAgreementDetailResponse>(
    QUERY_KEYS_SERVICE_AGREEMENTS.detail(id),
    queryFn
  );
};
